import { trackUserEvent } from 'app/client/analytics';
import type { User } from '../types/UserType';
import { getZrmUserInfo } from '@zg-rentals/clickstream';

// https://dataportal.zillowgroup.net/event-registry/3573
export const emitContinueAboveFoldEvent = (user: User) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '3573',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_start_page',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'top_address_form',
      trigger_source_nm: 'price_my_rental_address_submit',
    },
    semantic: {
      semantic_event_nm: 'zrm_price_my_rental',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3596
export const emitContinueBelowFoldEvent = (user: User) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '3596',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_start_page',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'bottom_address_form',
      trigger_source_nm: 'price_my_rental_address_submit',
    },
    semantic: {
      semantic_event_nm: 'zrm_price_my_rental',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3643
export const emitSuccessEvent = (user: User) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '3643',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_results_page|success',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'zrm_price_my_rental_results_page|success',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3644
export const emitErrorEvent = (user: User) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '3644',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_results_page|error',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'zrm_price_my_rental_results_page|error',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3617
export const emitPostListingEvent = (user: User) =>
  trackUserEvent({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: '3617',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_results_page',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'top_button',
      trigger_source_nm: 'price_my_rental_post_listing',
    },
    semantic: {
      semantic_event_nm: 'zrm_price_my_rental',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3622
export const emitClaimHomeEvent = (user: User) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '3622',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_results_page',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'button_to_claim_home',
      trigger_source_nm: 'price_my_rental_claim_home_click',
    },
    semantic: {
      semantic_event_nm: 'zrm_price_my_rental',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });
